import React from "react";
import Dashboard from "./Dashboard";
import { useState, useEffect } from "react";
import { useActionData, useLocation } from "react-router-dom";
import placeholderAvatar from "./../images/placeholder-avatar.png";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";
import { set } from "date-fns";
import { is } from "date-fns/locale";
import "./UserProfileScreen.css";
// This is where the user ends up after logging in, or clicking "Home" in the navbar.
const UserProfileScreen = ({ patient, img, setSelectedSection }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isMedicalOpen, setIsMedicalOpen] = useState(false);
  const [isSCareOpen, setIsSCareOpen] = useState(false);
  const [isCarePOpen, setIsCarePOpen] = useState(false);
  const [about, setAbout] = useState(patient.about || "");
  const [modAbout, setModAbout] = useState(false);
  const [allergies, setAllergies] = useState(patient.allergies || "");
  const [medications, setMedications] = useState(patient.medications || "");
  const [conditions, setConditions] = useState(patient.conditions || "");
  const [modMedical, setModMedical] = useState(false);
  const [specialCare, setSpecialCare] = useState(patient.special_care || "");
  const [modSpecialCare, setModSpecialCare] = useState(false);
  const [isAboutLoading, setIsAboutLoading] = useState(false);
  const [isMedicalLoading, setIsMedicalLoading] = useState(false);
  const [isSCareLoading, setIsSCareLoading] = useState(false);
  const [modCarePrefer, setModCarePrefer] = useState(false);
  const [carePrefer, setCarePrefer] = useState(patient.selected_services || []);
  const [isCarePreferLoading, setIsCarePreferLoading] = useState(false);

  const [UserLandingData, setUserLandingData] = useState({
    username: "Guest",
    email: "guest@gmail.com",
  });

  const toggleModAbout = () => {
    setModAbout(!modAbout);
  };
  const handleChangeAbout = (event) => {
    setAbout(event.target.value);
  };

  const toggleModMedical = () => {
    setModMedical(!modMedical);
  };
  const handleChangeAllergies = (event) => {
    setAllergies(event.target.value);
  };
  const handleChangeMedications = (event) => {
    setMedications(event.target.value);
  };
  const handleChangeConditions = (event) => {
    setConditions(event.target.value);
  };

  const toggleModSpecialCare = () => {
    setModSpecialCare(!modSpecialCare);
  };
  const handleChangeSpecialCare = (event) => {
    setSpecialCare(event.target.value);
  };

  const updatePatientProfile = async (section) => {
    const url = `${API_IP}/api/patients`;
    switch (section) {
      case "about":
        setIsAboutLoading(true);
        const aboutData = {
          section: "about",
          patient_id: patient.patient_id,
          about: about,
        };
        const aboutRes = await axiosReqConfig(url, "PATCH", aboutData);
        if (aboutRes?.ok) {
          setIsAboutLoading(false);
          setModAbout(false);
          patient.about = about;
        } else {
          setIsAboutLoading(false);
        }
        break;
      case "medical":
        setIsMedicalLoading(true);
        const medicalData = {
          section: "medical",
          patient_id: patient.patient_id,
          allergies: allergies,
          medications: medications,
          conditions: conditions,
        };
        const medicalRes = await axiosReqConfig(url, "PATCH", medicalData);
        if (medicalRes?.ok) {
          setIsMedicalLoading(false);
          setModMedical(false);
          patient.allergies = allergies;
          patient.medications = medications;
          patient.conditions = conditions;
        } else {
          setIsMedicalLoading(false);
        }
        break;
      case "specialCare":
        setIsSCareLoading(true);
        const specialCareData = {
          section: "specialCare",
          patient_id: patient.patient_id,
          special_care: specialCare,
        };
        const specialCareRes = await axiosReqConfig(
          url,
          "PATCH",
          specialCareData,
        );
        if (specialCareRes?.ok) {
          setIsSCareLoading(false);
          setModSpecialCare(false);
          patient.special_care = specialCare;
        } else {
          setIsSCareLoading(false);
        }
        break;
      case "carePrefer":
        setIsCarePreferLoading(true);
        const carePreferData = {
          section: "carePrefer",
          patient_id: patient.patient_id,
          selected_services: carePrefer,
        };
        const carePreferRes = await axiosReqConfig(
          url,
          "PATCH",
          carePreferData,
        );
        if (carePreferRes?.ok) {
          setIsCarePreferLoading(false);
          setModCarePrefer(false);
          patient.selected_services = carePrefer;
        } else {
          setIsCarePreferLoading(false);
        }
        break;
      default:
        console.error("Invalid section for updatePatientProfile");
        return;
    }
  };

  const services = [
    "Ambulating",
    "Bathing",
    "Dressing",
    "Eating",
    "Hygiene/Grooming",
    "Meal Preparation",
    "Showers",
    "Transferring",
    "Medication Management",
    "Laundry",
    "Declutter/Organization",
    "Transport to/from appointments",
    "Personal Errands",
    "Grocery Shopping",
  ];
  const [checkedItems, setCheckedItems] = useState({
    companionship: true,
    transferring: false,
    dressing: false,
    ambulating: false,
    bathing: false,
    eating: false,
    transportation: true,
    groceryShopping: true,
    showers: false,
    mealPreparation: true,
    personalErrands: false,
    hygieneGrooming: false,
    medicationManagement: true,
    declutterOrganization: false,
    laundry: false,
  });

  const toggleAccordion = (value) => {
    switch (value) {
      case "Profile":
        setIsProfileOpen(!isProfileOpen);
        return;
      case "Medical":
        setIsMedicalOpen(!isMedicalOpen);
        return;
      case "SCare":
        setIsSCareOpen(!isSCareOpen);
        return;
      case "CareP":
        setIsCarePOpen(!isCarePOpen);
        return;
      default:
        return;
    }
  };
  const CarePreferencesItem = ({ service }) => {
    const [checkItem, setCheckItem] = useState(carePrefer.includes(service));
    console.log();
    const handleCheckboxChange = (e) => {
      const isChecked = e.target.checked;
      setCheckItem(!checkItem);

      if (isChecked) {
        setCarePrefer((prev) => [...prev, e.target.name]);
      } else {
        setCarePrefer((prev) => prev.filter((item) => item !== e.target.name));
      }
    };

    return (
      <label
        className={`Preferences-checkbox-item ${checkItem ? "active" : ""}`}
      >
        <input
          type="checkbox"
          name={`${service}`}
          checked={checkItem}
          disabled={!modCarePrefer}
          onChange={handleCheckboxChange}
          className="Preferences-checkbox"
        />
        {service}
      </label>
    );
  };
  return (
    <>
      <div className="screen-container">
        <div className="screen-header">
          <div
            className="screen-header-text"
            style={{ flexDirection: "row", alignItems: "center", gap: "15px" }}
          >
            <img
              src={require(`../images/back_icon.png`)}
              alt="Profile"
              className="profile-back-icon"
              onClick={() => {
                setSelectedSection("Patient");
              }}
              style={{
                cursor: "pointer",
                width: "30px",
                height: "30px",
                objectFit: "contain",
              }}
            />
            <h1 className="screen-title">Member Profile</h1>
          </div>
        </div>
        <div className="profile-section">
          <div className="profile-card">
            <div className="proAvatarContainer">
              <img
                src={require(`../images/avatar_placeholder_${img}.png`)}
                alt="Profile"
                className="profile-image"
              />
            </div>
            <div className="profile-info">
              <div className="info-section">
                <p>
                  <span className="icon">👤</span> Username
                </p>
                <p>
                  {patient.first_name} {patient.last_name}
                </p>
              </div>
              <div className="info-section">
                <p>
                  <span className="icon">📞</span> Phone Number
                </p>
                <p>NULL</p>
              </div>
              <div className="info-section">
                <p>
                  <span className="icon">✉️</span> Email
                </p>
                <p>{patient.account_email}</p>
              </div>
            </div>
            {/* <button className="edit-button">Edit</button> */}
          </div>
          <div className="proDetail-section">
            {/* Profile Section */}
            <div className="accordion-section">
              <div
                className="accordion-header"
                onClick={() => toggleAccordion("Profile")}
              >
                Tell us a little more about you
                <span>{isProfileOpen ? "▲" : "▼"}</span>
              </div>
              <div
                className={`accordion-content ${isProfileOpen ? "open" : ""}`}
              >
                <div className="text-section">
                  {modAbout ? (
                    <textarea
                      value={about}
                      onChange={handleChangeAbout}
                      rows={5}
                      maxLength={300}
                      placeholder={"Tell us a little more about you..."}
                      className="profile-textarea"
                    />
                  ) : (
                    <>
                      <p>
                        {patient.about !== "" && patient.about !== null
                          ? patient.about
                          : "No information provided."}
                      </p>
                    </>
                  )}
                </div>
                <div className="profile-actions">
                  {!modAbout ? (
                    <button
                      className="edit-button primary"
                      onClick={toggleModAbout}
                    >
                      Edit
                    </button>
                  ) : (
                    <>
                      <button
                        className="edit-button secondary"
                        disabled={isAboutLoading}
                        onClick={toggleModAbout}
                      >
                        Cancel
                      </button>
                      <button
                        className="edit-button primary"
                        disabled={isAboutLoading}
                        onClick={() => {
                          updatePatientProfile("about");
                        }}
                      >
                        {isAboutLoading ? "Saving..." : "Save"}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* Additional Accordion Sections */}
            <div className="accordion-section">
              <div
                className="accordion-header"
                onClick={() => toggleAccordion("Medical")}
              >
                Is there any medical information you would with us (optional)
                <span>{isMedicalOpen ? "▲" : "▼"}</span>
              </div>
              <div
                className={`accordion-content ${isMedicalOpen ? "open" : ""}`}
              >
                <div className="Med-contact-container">
                  <div className="Med-contact-card">
                    {/* <div className="Med-contact-header">
                    Emergency Contact Information
                  </div>
                  <div className="Med-contact-info">
                    <div className="Med-contact-item">
                      <span className="Med-icon">👤</span>
                      <span className="Med-contact-details">Hana Banana</span>
                    </div>
                    <div className="Med-contact-item">
                      <span className="Med-icon">📞</span>
                      <span className="Med-contact-details">555-555-5555</span>
                    </div>
                  </div>
                  <div className="Med-contact-info">
                    <div className="Med-contact-item">
                      <span className="Med-icon">📍</span>
                      <span className="Med-contact-details">
                        123 Fake St
                        <br />
                        Victoria, BC, Canada
                      </span>
                    </div>
                    <div className="Med-contact-item">
                      <span className="Med-icon">✉️</span>
                      <span className="Med-contact-details">
                        hbanana@gmail.com
                      </span>
                    </div>
                  </div> */}
                    <div className="Med-categories">
                      <div className="Med-category">
                        <div className="Med-category-title">Allergies</div>
                        {modMedical ? (
                          <textarea
                            value={allergies}
                            onChange={handleChangeAllergies}
                            rows={5}
                            maxLength={300}
                            placeholder={"Tell us a little more about you..."}
                            className="profile-textarea"
                          />
                        ) : (
                          <p>
                            {patient.allergies !== "" &&
                            patient.allergies !== null
                              ? patient.allergies
                              : "Tell us about your allergies"}
                          </p>
                        )}
                      </div>
                      <div className="Med-category">
                        <div className="Med-category-title">Medications</div>
                        {modMedical ? (
                          <textarea
                            value={medications}
                            onChange={handleChangeMedications}
                            rows={5}
                            maxLength={300}
                            placeholder={"Tell us a little more about you..."}
                            className="profile-textarea"
                          />
                        ) : (
                          <p>
                            {patient.medications !== "" &&
                            patient.medications !== null
                              ? patient.medications
                              : "Tell us about your medications"}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="Med-contact-card">
                    {/* <div className="Med-contact-header">Primary Physician</div>
                  <div className="Med-contact-info">
                    <div className="Med-contact-item">
                      <span className="Med-icon">👤</span>
                      <span className="Med-contact-details">Hana Banana</span>
                    </div>
                    <div className="Med-contact-item">
                      <span className="Med-icon">📞</span>
                      <span className="Med-contact-details">555-555-5555</span>
                    </div>
                  </div>
                  <div className="Med-contact-info">
                    <div className="Med-contact-item">
                      <span className="Med-icon">📍</span>
                      <span className="Med-contact-details">
                        123 Fake St
                        <br />
                        Victoria, BC, Canada
                      </span>
                    </div>
                    <div className="Med-contact-item">
                      <span className="Med-icon">✉️</span>
                      <span className="Med-contact-details">
                        hbanana@gmail.com
                      </span>
                    </div>
                  </div> */}
                    <div className="Med-categories">
                      <div className="Med-category">
                        <div className="Med-category-title">
                          Medical Conditions
                        </div>
                        {modMedical ? (
                          <textarea
                            value={conditions}
                            onChange={handleChangeConditions}
                            rows={5}
                            maxLength={300}
                            placeholder={"Tell us a little more about you..."}
                            className="profile-textarea"
                          />
                        ) : (
                          <p>
                            {patient.conditions !== "" &&
                            patient.contions !== null
                              ? patient.conditions
                              : "Tell us about your medical conditions"}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="profile-actions">
                  {modMedical ? (
                    <>
                      <button
                        className="edit-button secondary"
                        disabled={isMedicalLoading}
                        onClick={toggleModMedical}
                      >
                        Cancel
                      </button>
                      <button
                        className="edit-button primary"
                        disabled={isMedicalLoading}
                        onClick={() => updatePatientProfile("medical")}
                      >
                        {isMedicalLoading ? "Saving..." : "Save"}
                      </button>
                    </>
                  ) : (
                    <button
                      className="edit-button primary"
                      onClick={toggleModMedical}
                    >
                      Edit
                    </button>
                  )}
                </div>
                {/* // <button className="edit-button" onClick={toggleModMedical}>
              //   {modMedical ? "Save" : "Edit"}
              // </button> */}
              </div>
            </div>

            <div className="accordion-section">
              <div
                className="accordion-header"
                onClick={() => toggleAccordion("SCare")}
              >
                Is there any special care needs you would like us to be aware
                of! (optional)
                <span>{isSCareOpen ? "▲" : "▼"}</span>
              </div>
              <div className={`accordion-content ${isSCareOpen ? "open" : ""}`}>
                <div className="text-section">
                  {modSpecialCare ? (
                    <textarea
                      value={specialCare}
                      onChange={handleChangeSpecialCare}
                      rows={5}
                      maxLength={300}
                      placeholder={"Tell us a little more your special care."}
                      className="profile-textarea"
                    />
                  ) : (
                    <>
                      <p>
                        {patient.special_care !== "" &&
                        patient.special_care !== null
                          ? patient.special_care
                          : "Tell us about your special care needs."}
                      </p>
                    </>
                  )}
                </div>
                <div className="profile-actions">
                  {!modSpecialCare ? (
                    <button
                      className="edit-button primary"
                      onClick={toggleModSpecialCare}
                    >
                      Edit
                    </button>
                  ) : (
                    <>
                      <button
                        className="edit-button secondary"
                        disabled={isSCareLoading}
                        onClick={toggleModSpecialCare}
                      >
                        Cancel
                      </button>
                      <button
                        className="edit-button primary"
                        disabled={isSCareLoading}
                        onClick={() => {
                          updatePatientProfile("specialCare");
                        }}
                      >
                        {isSCareLoading ? "Saving..." : "Save"}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="accordion-section">
              <div
                className="accordion-header"
                onClick={() => toggleAccordion("CareP")}
              >
                Care Preferences
                <span>{isCarePOpen ? "▲" : "▼"}</span>
              </div>
              <div className={`accordion-content ${isCarePOpen ? "open" : ""}`}>
                <div className="Preferences-intro">
                  Please select all the services you are interested in
                </div>

                <div className="Preferences-checkbox-container">
                  {services.map((service, index) => {
                    return <CarePreferencesItem service={service} />;
                  })}
                </div>
                {/* <button className="edit-button">Edit</button> */}
                <div className="profile-actions">
                  {!modCarePrefer ? (
                    <button
                      className="edit-button primary"
                      onClick={() => setModCarePrefer(true)}
                    >
                      Edit
                    </button>
                  ) : (
                    <>
                      <button
                        className="edit-button secondary"
                        disabled={isCarePreferLoading}
                        onClick={() => {
                          setModCarePrefer(false);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="edit-button primary"
                        disabled={isCarePreferLoading}
                        onClick={() => {
                          updatePatientProfile("carePrefer");
                        }}
                      >
                        {isCarePreferLoading ? "Saving..." : "Save"}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfileScreen;
